import DependentQuestions from "@/containers/survey/components/DependentQuestions";
import { useTranslation } from "react-i18next";
import Field from "@/components/Field";
import FileTypeSelect from "../../FileTypeSelect";
import QuantityTypeSelect from "../../QuantityTypeSelect";
import Fieldset from "@/components/Fieldset";
import { isRequired } from "@/lib/form";
import { cfg } from "@/schemas/question/cfg";

interface QuestionFileProps {
  index: number;
}
const QuestionFile = ({ index }: QuestionFileProps) => {
  const { t } = useTranslation();

  return (
    <Fieldset>
      <Field
        name={`questions.${index}.cfg.type`}
        label={t("surveyEditor.fileType.fileType")}
        required={isRequired(cfg.shape.type)}
        render={({ field }) => <FileTypeSelect {...field} />}
      />
      <Field
        name={`questions.${index}.cfg.quantity`}
        label={t("surveyEditor.fileType.quantity")}
        required={isRequired(cfg.shape.quantity)}
        render={({ field }) => <QuantityTypeSelect {...field} />}
      />
      <DependentQuestions index={index} />
    </Fieldset>
  );
};

export default QuestionFile;
